import { HeroPresetCollectionApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useHeroPresetCollectionsAPI(): HeroPresetCollectionApi {
  return new HeroPresetCollectionApi(apiConfig);
}
